<template>
  <div class="ota-device-reboot">
    <v-card
      v-if="!updated" 
      class="reboot-content"
    >
      <v-row  
        align="center"
        justify="center"
        class="padding-top"
      >
        <v-col cols="3" class="d-flex justify-center">
          <v-icon 
            color="red"
            size="50"
          >
            mdi-alert
          </v-icon>
        </v-col>

        <v-col class="d-flex justify-center">
          Are you sure you wish to reboot this device?
        </v-col>
      </v-row>

      <v-row  
        align="center"
        justify="center"
        class="padding-bottom reboot-actions"
      >
        <v-btn
          color="red" 
          text
          @click="emitClose"
        >
          No
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="!loading"
          color="green"
          text
          @click="submit"
        >
          Yes
        </v-btn>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-row>
    </v-card>

    <v-card 
      v-if="updated && status"
      class="reboot-content"
    >
      <v-row  
        align="center"
        justify="center"
        class="padding-top"
      >
        <v-col cols="3" class="d-flex justify-center">
          <v-icon 
            color="green"
            size="50"
          >
            mdi-check
          </v-icon>
        </v-col>

        <v-col>
          The reboot request succeeded.
        </v-col>
      </v-row>

      <v-row  
        align="center"
        justify="center"
        class="padding-bottom reboot-actions"
      >
        <v-spacer></v-spacer>
        <v-btn 
          color="green"
          text
          @click="emitClose"
        >
          OK
        </v-btn>
      </v-row>
    </v-card>

    <v-card 
      v-if="updated && !status"
      class="reboot-content"
    >
      <v-row  
        align="center"
        justify="center"
        class="padding-top"
      >
        <v-col cols="3" class="d-flex justify-center">
          <v-icon 
            color="red"
            size="50"
          >
            mdi-alert
          </v-icon>
        </v-col>

        <v-col>
          The reboot request failed.
        </v-col>
      </v-row>

      <v-row  
        align="center"
        justify="center"
        class="padding-bottom reboot-actions"
      >
        <v-spacer></v-spacer>
        <v-btn 
          color="green"
          text
          @click="emitClose"
        >
          OK
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>

import {RebootDevice} from '@/services/API.js';

import { Logger } from "aws-amplify";
const logger = new Logger("Device Reboot");

export default {
  name: 'DeviceReboot',
  props: {
    org: {
      type: String,
      required: true
    },
    device: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      status: null,
      updated: false
    }
  },
  computed: {
    deviceID() {
      let device = this.device.devices.filter(item => {
        return item.is_defaultdevice === true  || item.is_default_device === true || item.is_default_device === "true";
      })
      return device[0].device_id;
    }
  },
  methods: {
    emitClose() {
      this.$emit('close');
    },
    handleState(state) {
      this.updated = true;
      this.status = state;
    },
    submit() {
      this.loading = true;

      RebootDevice(this.org, this.deviceID)
      .then(res => {
        let status = res.result.status;

        if (status == '200') {
          this.handleState(true);
          this.loading = false;
          logger.info('res here : ', res);
        }
        else {
          this.handleState(false);
          this.loading = false;
          logger.info('there was an error : ', status);
        }
      })
      .catch(err => {
        this.handleState(false);
        this.loading = false;
        logger.info('there was an error : ', err);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .ota-device-reboot {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;

    .reboot-content {
      background: white;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid grey 2px;
      width: 500px;

      .reboot-actions {
        padding-left: 1em;
        padding-right: 1em;
    }
  }

    .padding-top {
      padding-top: 1em;
    }

    .padding-bottom {
      padding-bottom: 1em;
    }
  }
</style>